import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=489b5be3&scoped=true"
import script from "./Dialog.vue?vue&type=script&lang=ts"
export * from "./Dialog.vue?vue&type=script&lang=ts"
import style0 from "./Dialog.vue?vue&type=style&index=0&id=489b5be3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b5be3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489b5be3')) {
      api.createRecord('489b5be3', component.options)
    } else {
      api.reload('489b5be3', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=489b5be3&scoped=true", function () {
      api.rerender('489b5be3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/Dialog.vue"
export default component.exports